import { makeStyles } from '@mui/styles';
import { body2 } from '../../shared/theme/text.styles';
import hexToRgba from 'hex-to-rgba';
import { grey } from '@mui/material/colors';

export const useFooterStyles = makeStyles((theme) => ({
  footerRoot: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: '520px',
    padding: '150px 0',
    width: '100vw',
    maxWidth: '100%',
    borderTop: '1px solid',
    borderTopColor: grey[400],
    backgroundColor: `${hexToRgba('#fb8222', 0)}`,
    zIndex: 10,
    overflow: 'hidden',

    [theme.breakpoints.down('lg')]: {
      textAling: 'center !important',
      height: 'auto',
      padding: '30px 0',
    },
  },

  whiteBall: {
    position: 'absolute',
    bottom: 0,
    width: 800,
    height: 800,
    zIndex: 9,
    borderRadius: '50%',
    background: `radial-gradient(50% 50% at 50% 50%, ${hexToRgba(
      theme.palette.background.main,
      0.4
    )} 0%, ${hexToRgba(theme.palette.background.main, 0)} 100%)`,
    animationDuration: '5s',
    animationIterationCount: 'infinite',
    animationDirection: 'alternate',
    animationTimingFunction: 'linear',

    [theme.breakpoints.down('lg')]: {
      bottom: '-10%',
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(196, 196, 196, 0.6) 0%, rgba(196, 196, 196, 0) 100%)',
    },

    '&.left': {
      animationName: '$ltr',
      opacity: 1,
      left: '-10%',
    },

    '&.right': {
      right: '-5%',
      opacity: 0,
      animationName: '$rtl',
      animationDelay: '1s',
    },
  },

  '@keyframes ltr': {
    '0%': {
      left: '-10%',
      opacity: 1,
    },

    '50%': {
      opacity: 0,
    },

    '80%': {
      opacity: 0.6,
    },

    '100%': {
      opacity: 1,
      left: '100%',
    },
  },

  '@keyframes rtl': {
    '0%': {
      right: '-5%',
      opacity: 0,
    },

    '40%': {
      opacity: 1,
    },

    '100%': {
      right: '100%',
    },
  },

  gradient: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 0,
    background: 'rgba(58, 123, 255, 0.06)',
    backdropFilter: 'blur(10px)',
  },

  addressAndBrand: {
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center !important',
      textAlign: 'center',
    },
  },

  logoWrapper: {
    width: 250,
    height: 100,
    marginBottom: '24px',

    '& .logo': {
      width: '100%',
      height: '100%',
      objectSize: 'contain',
    },
  },

  address: {
    ...body2,

    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },

  footerForm: {
    width: '40%',

    [theme.breakpoints.down('lg')]: {
      display: 'none !important',
    },
  },
}));
